module.exports = __webpack_public_path__ + "img/18.71566fa1.jpg";